import React from "react";
import iconSvg from '../../icons/home-sharp.svg';
import "./TopBar.css";
import { useLocation } from "react-router-dom";
import { useRol } from "../../Context";
import { MyUser } from "../MyUser";
import logoV3 from '../../icons/logo-sidebar.png';
import { secureSetItem } from '../../utils/encryption';


function TopBar() {
    const { projects, vacantCode, setVacantCode, setSelectedCompanyId, setButtonPressed } = useRol();
    const location = useLocation();
    const rutaActual = location.pathname.substring(1);
    const formattedText = rutaActual.replace(/-/g, ' ');

    const handleSelectChange = (event) => {
        const valorSeleccionado = event.target.value;
        setVacantCode(valorSeleccionado);
        const selectedProject = projects?.flatMap((company) => company.projects).find((project) => project.vacant_code === valorSeleccionado);
        if (selectedProject) {
            setSelectedCompanyId(selectedProject.company_id);
            // Guardar el proyecto seleccionado en localStorage
            secureSetItem('vacantCode', valorSeleccionado);
            secureSetItem('selectedCompanyId', selectedProject.company_id.toString());
            // Proyecto guardado en localStorage
            // Activar buttonPressed para que se carguen los datos del nuevo proyecto
            setButtonPressed(true);
        } else {
            setSelectedCompanyId(null);
        }
    };

    const activeCompanies = projects
        ?.map(company => ({
            ...company,
            projects: company.projects?.filter(p => p.active !== false) ?? [],
        }))
        .filter(company => company.projects.length > 0);

    const renderProjectOptions = (companies) =>
        companies?.map((company) => (
            <optgroup key={company.id} label={company.trade_name}>
                {company.projects.map((project) => (
                    <option key={project.vacant_code} value={project.vacant_code}>
                        {project.vacant_name}
                    </option>
                ))}
            </optgroup>
        ));

    return (
        <>
            {/* topbar web */}
            <div className="topbar" >
                <div className="titulo logo-v3">
                    <img src={logoV3} alt="logo" />
                </div>
                <div className="titulo title-topbar">
                    <label>{formattedText}</label>
                </div>
                <div className="separacion titulo">
                </div>
                <div className="selector titulo">
                    <div className="icon-home titulo">
                        <img src={iconSvg} alt="" />
                    </div>
                    <select value={vacantCode || ''} onChange={handleSelectChange}>
                        {(!activeCompanies || activeCompanies.length === 0) && (
                            <option value="" disabled>Sin proyecto</option>
                        )}
                        {renderProjectOptions(activeCompanies)}
                    </select>
                </div>
                <MyUser />
            </div>
            {/* topbar movil */}
            <div className="header-movil">
                <div className="container-logo-movil" >
                    <img src="Assets/img/Isologo-blanco.png" alt="logo en blanco"></img>
                    <select value={vacantCode || ''} onChange={handleSelectChange} className="selector-movil">
                        {(!activeCompanies || activeCompanies.length === 0) && (
                            <option value="" disabled>Sin proyecto</option>
                        )}
                        {renderProjectOptions(activeCompanies)}
                    </select>
                </div>
            </div>
        </>
    )
}

export { TopBar }